import { render } from "./KskItemCard.vue?vue&type=template&id=4e4ce269&scoped=true"
import script from "./KskItemCard.vue?vue&type=script&lang=js"
export * from "./KskItemCard.vue?vue&type=script&lang=js"

import "./KskItemCard.vue?vue&type=style&index=0&id=4e4ce269&scoped=true&lang=css"

import exportComponent from "/var/www/html/online-ordering/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e4ce269"]])

export default __exports__